import { render, staticRenderFns } from "./appkeyComponent.vue?vue&type=template&id=4fa6047d&scoped=true&"
import script from "./appkeyComponent.vue?vue&type=script&lang=js&"
export * from "./appkeyComponent.vue?vue&type=script&lang=js&"
import style0 from "./appkeyComponent.vue?vue&type=style&index=0&id=4fa6047d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6047d",
  null
  
)

export default component.exports